import { useState } from 'react'
import { onChange } from '../../../../../../../../../utils/types'
import { Dayjs } from 'dayjs'
import { DataActivityForm } from '../../create/types'

const useCreatEdit = () => {
  const [dataActivity, setDataActivity] = useState<DataActivityForm>()
  const [dataDestination, setDataDestination] = useState<Record<string, unknown>>({})

  const onChangeCrud: onChange = ({ target }) => {
    const { name, value } = target
    setDataActivity((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const onChangeDestination: onChange = ({ target }) => {
    const { name, value } = target
    setDataDestination((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleChangeCrud = ({ name,date }:{name:string,date:Dayjs}) => {
    setDataActivity((prev) => ({
      ...prev,
      [name]: date,
    }))
  }

  const handleDataActivity = (data?: DataActivityForm) => {
    setDataActivity(data ?? {})
  }

  const handleDataDestination = (data?: Record<string, unknown>) => {
    setDataDestination(data ?? {})
  }

  return { dataActivity, handleDataActivity, onChangeCrud, handleChangeCrud, dataDestination, onChangeDestination, handleDataDestination }
}

export { useCreatEdit }